import commonAction from './commonAction';

/**
 * Метод загрузки массива точек для карты
 * @param {string} mapType Тип карты
 */
export const loadPlacemarks = (filter = {}) => {
	return dispatch => commonAction(dispatch, 'post', '/placemarks', {filter}, 'LOAD_PLACEMARKS', 'placemarks');
} 



// WEBPACK FOOTER //
// ./actions/mapActions.js